import React from "react";
import TurnrInput from "~/components/input/TurnrInput.jsx";
import TurnrDropdownSelect from "~/components/input/TurnrDropdownSelect.jsx";
import { InputGridWrapper, SettingsContainerWrapper } from "./settingComponents";
import { EXCHANGE_POLICIES } from "~/constants";

export default function AdminSettings(props) {
    const { iFrameData, appProps } = props;
    return (
        <SettingsContainerWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect
                    size={"small"}
                    fullWidth={true}
                    {...props.productsBundleMock}
                    onChange={props.setProductsBundleMock}
                    options={iFrameData?.productsBundleMocks || []}
                    label="Demo Products"
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect size={"small"} fullWidth={true} {...props.merchant} onChange={props.setMerchant} options={appProps.merchantsService?.data || []} label="Merchant" />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrInput size={"small"} label="Sender Email" fullWidth={true} {...props.senderEmail} onChange={props.setSenderEmail} />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrInput size={"small"} label="Shop Subdomain" fullWidth={true} {...props.shopSubdomain} onChange={props.setShopSubdomain} />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect size={"small"} label="Exchange Policy" fullWidth={true} {...props.exchangePolicy} options={Object.values(EXCHANGE_POLICIES)} onChange={props.setExchangePolicy} />
            </InputGridWrapper>
        </SettingsContainerWrapper>
    );
}
